

export class Employee_Dashboard_SalayAndDeduction implements IEmployee_Dashboard_SalayAndDeduction {
    salaryMonth!: Date | undefined;
    deduction!: number;
    finalSalary!: number;

    constructor(data?: IEmployee_Dashboard_SalayAndDeduction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salaryMonth = _data["salaryMonth"] ? new Date(_data["salaryMonth"].toString()) : <any>undefined;
            this.deduction = _data["deduction"];
            this.finalSalary = _data["finalSalary"];
        }
    }

    static fromJS(data: any): Employee_Dashboard_SalayAndDeduction {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_SalayAndDeduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salaryMonth"] = this.salaryMonth ? this.salaryMonth.toISOString() : <any>undefined;
        data["deduction"] = this.deduction;
        data["finalSalary"] = this.finalSalary;
        return data; 
    }
}

export interface IEmployee_Dashboard_SalayAndDeduction {
    salaryMonth: Date | undefined;
    deduction: number;
    finalSalary: number;
}

